import { generateClient } from 'aws-amplify/api';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

export const saveMedicalQuizResults = async (userId, bestSpecialties, worstSpecialties, username, rawAnswers) => {
  try {
    // First verify user is authenticated and has valid session
    let user;
    try {
      user = await getCurrentUser();
      if (!user) throw new Error('No authenticated user');
    } catch (e) {
      throw new Error('Please sign in to save your results');
    }

    const attributes = await fetchUserAttributes();
    const sub = attributes.sub;

    // First check if result exists
    const { data } = await client.graphql({
      query: queries.listMedicalQuizResults,
      variables: {
        filter: { 
          userId: { eq: sub },
          owner: { eq: username }
        },
        limit: 1
      },
      authMode: 'userPool'
    });

    const input = {
      userId: sub,
      bestMatches: JSON.stringify(bestSpecialties.map(s => ({ name: s.name, score: s.totalScore }))),
      worstMatches: JSON.stringify(worstSpecialties.map(s => ({ name: s.name, score: s.totalScore }))),
      domainScores: JSON.stringify(rawAnswers),
      owner: username
    };

    if (data.listMedicalQuizResults.items.length > 0) {
      const existingResult = data.listMedicalQuizResults.items[0];
      await client.graphql({
        query: mutations.updateMedicalQuizResult,
        variables: {
          input: {
            id: existingResult.id,
            _version: existingResult._version,
            ...input
          }
        },
        authMode: 'userPool'
      });
    } else {
      await client.graphql({
        query: mutations.createMedicalQuizResult,
        variables: { input },
        authMode: 'userPool'
      });
    }

    return true;
  } catch (error) {
    console.error('Save error:', error);
    throw error;
  }
};
